import { createRouter, createWebHashHistory } from "vue-router";
import store from "@/store";

import LandingView from "@/views/LandingView.vue";
import ActivityView from "@/views/ActivityView.vue";

import { adminRoutes, authUser } from "@/admin/admin.js";

/*
 * All routes should be lowercase.
 */
export let routes = [
  {
    path: store.getters.useLandingPage ? "/" : "/landing",
    name: "Landing",
    component: LandingView,
    beforeEnter: store.getters.useAuth ? authUser : null
  },
  {
    path: store.getters.useLandingPage ? "/activity" : "/",
    name: "Activity",
    component: ActivityView,
    beforeEnter: store.getters.useAuth ? authUser : null
  }
];

/**
 * If the application uses authentication, then add the admin routes.
 */
if (store.getters.useAuth) {
  routes = [...routes, ...adminRoutes];
}

/*
 *
 * https://router.vuejs.org/guide/essentials/history-mode.html#hash-mode
 *
 * We use hash mode (createWebHashHistory), instead of
 * html5 mode (createWebHistory) so that it works on our S3 deployments.
 * The html5 mode is more SEO-friendly, but that isn't a concern with our
 * applications.
 */
/*
 * The 'linkExactActiveClass' is intended to style any router-view which
 * connects to the active view with the bold. It primarily will appear
 * in the `navbar`, but it will also bold any router-views, including buttons.
 */
const router = createRouter({
  linkExactActiveClass: "fw-bold",
  history: createWebHashHistory(),
  scrollBehavior() {
    return { top: 0, left: 0 };
  },
  routes
});

export default router;
